import { render, staticRenderFns } from "./Squared.vue?vue&type=template&id=1ab02450&scoped=true&"
import script from "./Squared.vue?vue&type=script&lang=js&"
export * from "./Squared.vue?vue&type=script&lang=js&"
import style0 from "./Squared.vue?vue&type=style&index=0&id=1ab02450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab02450",
  null
  
)

export default component.exports